<script lang="ts">
    import {formatIntervalObjectToReadableForm, isDateInInterval, isIntervalStringValid, parseIntervalStringToObject} from 'shared/ui-widgets/daterange-picker';
    import {getLocalization} from 'src/core';
    import {exists} from 'shared/utils/custom-utils';
    import {DateTime} from 'luxon';
    import {tooltip} from 'shared/ui-widgets/tooltip/use.tooltip';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let value: string;

    const localize = getLocalization();

    $: intervalObject = isIntervalStringValid(value) ? parseIntervalStringToObject(value) : null;
</script>

{#if exists(intervalObject)}
    {@const isActiveToday = isDateInInterval(DateTime.now(), intervalObject)}

    <span class="active-today-indicator"
          use:tooltip={isActiveToday ? 'V tento moment aktivní' : 'Není v tento moment aktivní'}
          class:active={isActiveToday}>

        <UIcon icon={isActiveToday ? 'check-circle' : 'cross-circle'}/>
    </span>

    <span>{formatIntervalObjectToReadableForm(intervalObject, localize)}</span>
{:else}
    <span class="invalid-interval">INVALID INTERVAL: {value}</span>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";

    @indicator-size: 20px;

    .active-today-indicator {
        background-color: var(--danger-red);
        color: white;
        border-radius: @border-radius-default;
        width: @indicator-size;
        height: @indicator-size;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: @spacing-xs;
        font-size: @font-size-small;
        border: 1px solid @themed-border-default;

        &.active {
            background-color: var(--success-green);
        }
    }

    .invalid-interval {
        color: var(--danger-red);
    }
</style>